export const getTokenFromStorage = () => {
  return localStorage.getItem("token") || missing_token
}
export const setTokenInStorage = (token: string) => {
  localStorage.setItem("token", token)
}
export const missing_token = "MISSING_TOKEN"

export const getTripIDFromStorage = () => {
  return localStorage.getItem("tripID") || missing_trip_id
}
export const setTripIDInStorage = (token: string) => {
  localStorage.setItem("tripID", token)
}
export const missing_trip_id = "MISSING_TRIP_ID"
